const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M509.64,290.766l-59.444-59.444l-16.653,17.161l-60.235-60.235l-28.817-6.952l-33.244,21.282 l50.728,50.728l-39.671,0.35L190.34,121.691l-25.566,3.434l-14.932,36.466l92.77,92.77L56.889,256l120.172,120.172l-34.838,22.05 L256,512l0,0C385.591,512,492.675,415.703,509.64,290.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M440.385,284.444H113.778v-56.889h326.608c8.132,0,14.726,6.592,14.726,14.726v27.439 C455.111,277.852,448.517,284.444,440.385,284.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09112"
    },
    d: "M113.778,255.569v28.875h326.608c8.132,0,14.726-6.592,14.726-14.726v-14.15H113.778z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.778,
    y: 227.556,
    style: {
      fill: "#31BAFD"
    },
    width: 302.839,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.778,
    y: 256,
    style: {
      fill: "#2B9ED8"
    },
    width: 302.839,
    height: 28.444
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEE187"
    },
    points: "113.778,227.556 56.889,256 113.778,284.444 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC61B"
    },
    points: "57.751,255.569 56.889,256 113.778,284.444 113.778,255.569 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#59595B"
    },
    points: "56.889,256 83.466,269.288 83.466,242.712 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#272525"
    },
    points: "57.751,255.569 56.889,256 83.466,269.288 83.466,255.569 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 170.667,
    cy: 142.222,
    r: 28.444
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M170.667,113.778c-0.193,0-0.381,0.026-0.574,0.029v56.83c0.191,0.003,0.379,0.029,0.574,0.029 c15.71,0,28.444-12.734,28.444-28.444S186.375,113.778,170.667,113.778z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.222,
    y: 312.889,
    style: {
      fill: "#FFC61B"
    },
    width: 85.333,
    height: 85.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.32,
    y: 312.889,
    style: {
      fill: "#EAA22F"
    },
    width: 43.236,
    height: 85.333
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "311.249,202.578 329.871,141.667 373.31,188.249 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0D1D3"
    },
    points: "329.871,141.667 329.723,142.152 343.724,195.081 373.31,188.249 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillSvgrepoCom);
export default __webpack_public_path__ + "static/media/skill-svgrepo-com.4b8d16ce5126bc2cc31b405dab22bdc7.svg";
export { ForwardRef as ReactComponent };